import {
  createContext,
  Dispatch,
  ReactElement,
  ReactNode,
  SetStateAction,
  useContext
} from 'react';
import { FormInstance } from 'antd';

type RegisterProviderProps = {
  children: ReactNode;
  value: {
    selectedUserType: number;
    setSelectedUserType: Dispatch<SetStateAction<number>>;
    form: FormInstance;
    eventId: string;
  };
};

const RegisterContext = createContext<RegisterProviderProps['value']>({
  form: {} as FormInstance,
  selectedUserType: 0,
  setSelectedUserType: () => {},
  eventId: ''
});

export const RegisterProvider = (
  props: RegisterProviderProps
): ReactElement => {
  return (
    <RegisterContext.Provider value={props.value}>
      {props.children}
    </RegisterContext.Provider>
  );
};

export const useRegisterValues = (): RegisterProviderProps['value'] => {
  return useContext(RegisterContext);
};
